// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.docManag_container {
  width: 100%;
  background-color: rgba(0, 255, 255, 0);
  padding: 6%;
  display: flex;
  justify-content: center;
  overflow-y: scroll;
}

.docManag_content {
  background-color: rgba(255, 255, 255, 0);
  width: 100%;
  height: 60vh;
}

.content_header {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.content_header h1 {
  size: 32px;
  font-weight: 500;
  margin: 1rem 0;
}

.content_header p {
  size: 16px;
  font-weight: 400;
  width: 430px;
  line-height: 25px;
  margin: 0 0;
}

.content_container {
  margin-top: 3rem;
  height: 60vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.content_menu h3 {
  font-weight: 500;
}

.menu_btn {
  height: 44px;
  width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 0.3rem;
  background-color: white;
  color: var(--primary-main);
  border: 1px solid var(--primary-main);
  border-radius: 4px;
}

.menu_btn_delete {
  color: var(--error-main);
  border: 1px solid var(--error-main);
}

.menu_btn:disabled {
  border: 1px solid var(--action-disabled);
  border-radius: 4px;
  color: var(--action-disabled);
  cursor: not-allowed;
}

.menu_btn:disabled:hover {
  cursor: not-allowed;
}

.menu_btn:hover {
  cursor: pointer;
}

.upload_btn:disabled {
  background-color: #d0d0ce;
  color: #53565a;
  cursor: not-allowed;
  font-weight: 400;
}

.upload_btn:disabled:hover {
  cursor: not-allowed;
}

.menu_items hr {
  height: 90%;
  width: 0.05vw;
  border-width: 0;
  color: #a7a8aa;
  background-color: #a7a8aa;
  margin: 0 1rem;
}

.upload_btn {
  height: 90%;
  display: flex;
  padding: 8px 15px;
  gap: 3px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-main);
  border: none;
  border-radius: 5px;
  margin: 0 0.3rem;
  color: white;
  font-family:
    "Open Sans",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
}

.table_container {
  width: 70vw;
  transition: width 0.3s ease;
}

.selected .table_container {
  width: 50vw;
}

.files_list_container {
  display: none;
  height: auto;
  overflow: hidden;
  width: 0;
  margin-left: 2rem;
  transition: width 0.3s ease;
}

.search-bar-container {
  width: 30%;
}

.selected-side-header {
  height: 4rem;
  background-color: #ffffff;
  border-bottom: 1px solid #a7a8aa;
  display: flex;
  align-items: center;
  padding: 0 2rem;
}

.selected .files_list_container {
  display: block;
  width: 20vw;
  overflow: scroll;
}

.files_list_container h3 {
  margin: 0;
}

.remove_icon {
  cursor: pointer;
}

.upload_btn:hover {
  cursor: pointer;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-container .tooltip-text {
  visibility: hidden;
  width: auto;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
}

.action_menu {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-left: 8px;
}

.action_menu button {
  border: none;
  background-color: transparent;
  display: flex;
  align-items: center;
}

.action_menu button:hover {
  cursor: pointer;
}

/* OK */
.content_menu {
  height: auto;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-top: 1px solid rgba(224, 224, 224, 1);
  border-left: 1px solid rgba(224, 224, 224, 1);
  border-right: 1px solid rgba(224, 224, 224, 1);
  padding: 1rem 1rem;
  justify-content: space-between;
}

.grid-header {
  border: 1px solid #d0d0ce;
  border-bottom: 0px;
  padding: 8px 16px;
  height: 35px;
}

.menu_items {
  align-items: center;
}

.footer {
  width: 100%;
  background-color: white;
}

.custom-footer {
  width: calc(100% + 400px);
  display: flex;
  align-items: end;
  justify-content: end;
  background-color: white;
  border: 1px solid #ddd;
  border: 1px solid #f5f5f5;
}

.selected-side-content {
  display: flex;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #f5f5f5;
  padding: 15px;
  height: calc(100% - 109px);
}

.side-content-container {
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 1rem;
}

.file_item_list {
  height: auto;
  align-items: center;
  justify-content: space-between;
  margin: 0.2rem 0;
  padding: 0 1rem 0 0.5rem;
}

.grid-layout {
  display: grid;
  grid-template-areas: "grid-side selected-side";
  grid-template-columns: 8fr 1.5fr;
}

.grid-side {
  grid-area: grid-side;
  max-width: 100%;
  overflow: auto;
}

.selected-side {
  border-top: 1px solid rgb(201, 201, 201);
  border-right: 1px solid rgb(201, 201, 201);
  overflow-y: auto;
  overflow-x: hidden;
  width: 400px;
}

.fileType_bullet_container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
}

.fileType_bullet {
  height: 20px;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  border-radius: 4px;

  &.file {
    background-color: rgb(94, 94, 94);
    color: white;
  }

  &.folder {
    background-color: white;
    border: 1px solid #515152;
    color: #515152;
    width: 2.5rem;
  }
}

.column_header_container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.reset_btn_container {
  width: 100%;
  display: flex;
  justify-content: end;
  align-self: flex-end;
  padding: 0 0.5rem;
}

.clear_btn_manag {
  border: none;
  color: var(--primary-main);
  background-color: transparent;
  cursor: pointer;
  padding: 0;
}

.clear_btn_manag h4 {
  font-weight: 400;
  font-size: 14px;
}

.filter_container {
  height: auto;
  width: 20vw;
  padding: 1rem 2rem;
}

.selection_container {
  width: 100%;
  background-color: transparent;
  border: 1px solid #d0d0ce;
  border-radius: 5px;
  height: 2rem;
  display: flex;
  flex-direction: row;
}

.selection_container button {
  width: 50%;
  height: 100%;
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 0 1rem;
}

.selection_container button:hover {
  background-color: #f2f7e9;
}

.selection_container button:first-child {
  border-right: 1px solid #d0d0ce;
}

.filter_footer {
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: end;
  margin-top: 3rem;
}

.btn {
  height: 2.3rem;
  width: 5rem;
  margin-left: 1rem;
  cursor: pointer;
}

.filter_cancel {
  border: 1px solid var(--primary-main);
  color: var(--primary-main);
  border-radius: 5px;
  background-color: transparent;
}

.filter_apply {
  border: 1px solid var(--primary-main);
  color: white;
  border-radius: 5px;
  background-color: var(--primary-main);
}

.filter_apply:disabled {
  background-color: #d0d0ce;
  color: #53565a;
  cursor: not-allowed;
  border: none;
}

.items_filter_list {
  height: 15vh;
  width: 90;
  border: 1px solid #d0d0ce;
  background-color: #53565a00;
  margin-top: 1rem;
  border-radius: 5px;
  padding: 0rem 1rem;
  overflow-y: scroll;
}

.filter_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.row_header_btn {
  background-color: transparent;
  border: none;
  width: 100%;
  padding: 0;
}

.header_name_container {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/css/documentManagement.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,sCAAsC;EACtC,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ;;;;;;;;;;;;cAYY;AACd;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA,OAAO;AACP;EACE,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,4CAA4C;EAC5C,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;;EAElB;IACE,iCAAiC;IACjC,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb","sourcesContent":[".docManag_container {\n  width: 100%;\n  background-color: rgba(0, 255, 255, 0);\n  padding: 6%;\n  display: flex;\n  justify-content: center;\n  overflow-y: scroll;\n}\n\n.docManag_content {\n  background-color: rgba(255, 255, 255, 0);\n  width: 100%;\n  height: 60vh;\n}\n\n.content_header {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.content_header h1 {\n  size: 32px;\n  font-weight: 500;\n  margin: 1rem 0;\n}\n\n.content_header p {\n  size: 16px;\n  font-weight: 400;\n  width: 430px;\n  line-height: 25px;\n  margin: 0 0;\n}\n\n.content_container {\n  margin-top: 3rem;\n  height: 60vh;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.content_menu h3 {\n  font-weight: 500;\n}\n\n.menu_btn {\n  height: 44px;\n  width: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 0.3rem;\n  background-color: white;\n  color: var(--primary-main);\n  border: 1px solid var(--primary-main);\n  border-radius: 4px;\n}\n\n.menu_btn_delete {\n  color: var(--error-main);\n  border: 1px solid var(--error-main);\n}\n\n.menu_btn:disabled {\n  border: 1px solid var(--action-disabled);\n  border-radius: 4px;\n  color: var(--action-disabled);\n  cursor: not-allowed;\n}\n\n.menu_btn:disabled:hover {\n  cursor: not-allowed;\n}\n\n.menu_btn:hover {\n  cursor: pointer;\n}\n\n.upload_btn:disabled {\n  background-color: #d0d0ce;\n  color: #53565a;\n  cursor: not-allowed;\n  font-weight: 400;\n}\n\n.upload_btn:disabled:hover {\n  cursor: not-allowed;\n}\n\n.menu_items hr {\n  height: 90%;\n  width: 0.05vw;\n  border-width: 0;\n  color: #a7a8aa;\n  background-color: #a7a8aa;\n  margin: 0 1rem;\n}\n\n.upload_btn {\n  height: 90%;\n  display: flex;\n  padding: 8px 15px;\n  gap: 3px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--primary-main);\n  border: none;\n  border-radius: 5px;\n  margin: 0 0.3rem;\n  color: white;\n  font-family:\n    \"Open Sans\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    \"Roboto\",\n    \"Oxygen\",\n    \"Ubuntu\",\n    \"Cantarell\",\n    \"Fira Sans\",\n    \"Droid Sans\",\n    \"Helvetica Neue\",\n    sans-serif;\n}\n\n.table_container {\n  width: 70vw;\n  transition: width 0.3s ease;\n}\n\n.selected .table_container {\n  width: 50vw;\n}\n\n.files_list_container {\n  display: none;\n  height: auto;\n  overflow: hidden;\n  width: 0;\n  margin-left: 2rem;\n  transition: width 0.3s ease;\n}\n\n.search-bar-container {\n  width: 30%;\n}\n\n.selected-side-header {\n  height: 4rem;\n  background-color: #ffffff;\n  border-bottom: 1px solid #a7a8aa;\n  display: flex;\n  align-items: center;\n  padding: 0 2rem;\n}\n\n.selected .files_list_container {\n  display: block;\n  width: 20vw;\n  overflow: scroll;\n}\n\n.files_list_container h3 {\n  margin: 0;\n}\n\n.remove_icon {\n  cursor: pointer;\n}\n\n.upload_btn:hover {\n  cursor: pointer;\n}\n\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip-container .tooltip-text {\n  visibility: hidden;\n  width: auto;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 5px;\n  padding: 5px;\n  position: absolute;\n  z-index: 1;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  white-space: nowrap;\n}\n\n.tooltip-container:hover .tooltip-text {\n  visibility: visible;\n}\n\n.action_menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  margin-left: 8px;\n}\n\n.action_menu button {\n  border: none;\n  background-color: transparent;\n  display: flex;\n  align-items: center;\n}\n\n.action_menu button:hover {\n  cursor: pointer;\n}\n\n/* OK */\n.content_menu {\n  height: auto;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  border-top: 1px solid rgba(224, 224, 224, 1);\n  border-left: 1px solid rgba(224, 224, 224, 1);\n  border-right: 1px solid rgba(224, 224, 224, 1);\n  padding: 1rem 1rem;\n  justify-content: space-between;\n}\n\n.grid-header {\n  border: 1px solid #d0d0ce;\n  border-bottom: 0px;\n  padding: 8px 16px;\n  height: 35px;\n}\n\n.menu_items {\n  align-items: center;\n}\n\n.footer {\n  width: 100%;\n  background-color: white;\n}\n\n.custom-footer {\n  width: calc(100% + 400px);\n  display: flex;\n  align-items: end;\n  justify-content: end;\n  background-color: white;\n  border: 1px solid #ddd;\n  border: 1px solid #f5f5f5;\n}\n\n.selected-side-content {\n  display: flex;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: #f5f5f5;\n  padding: 15px;\n  height: calc(100% - 109px);\n}\n\n.side-content-container {\n  overflow-y: scroll;\n  overflow-x: hidden;\n  padding: 1rem;\n}\n\n.file_item_list {\n  height: auto;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0.2rem 0;\n  padding: 0 1rem 0 0.5rem;\n}\n\n.grid-layout {\n  display: grid;\n  grid-template-areas: \"grid-side selected-side\";\n  grid-template-columns: 8fr 1.5fr;\n}\n\n.grid-side {\n  grid-area: grid-side;\n  max-width: 100%;\n  overflow: auto;\n}\n\n.selected-side {\n  border-top: 1px solid rgb(201, 201, 201);\n  border-right: 1px solid rgb(201, 201, 201);\n  overflow-y: auto;\n  overflow-x: hidden;\n  width: 400px;\n}\n\n.fileType_bullet_container {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n}\n\n.fileType_bullet {\n  height: 20px;\n  width: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  border-radius: 4px;\n\n  &.file {\n    background-color: rgb(94, 94, 94);\n    color: white;\n  }\n\n  &.folder {\n    background-color: white;\n    border: 1px solid #515152;\n    color: #515152;\n    width: 2.5rem;\n  }\n}\n\n.column_header_container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.reset_btn_container {\n  width: 100%;\n  display: flex;\n  justify-content: end;\n  align-self: flex-end;\n  padding: 0 0.5rem;\n}\n\n.clear_btn_manag {\n  border: none;\n  color: var(--primary-main);\n  background-color: transparent;\n  cursor: pointer;\n  padding: 0;\n}\n\n.clear_btn_manag h4 {\n  font-weight: 400;\n  font-size: 14px;\n}\n\n.filter_container {\n  height: auto;\n  width: 20vw;\n  padding: 1rem 2rem;\n}\n\n.selection_container {\n  width: 100%;\n  background-color: transparent;\n  border: 1px solid #d0d0ce;\n  border-radius: 5px;\n  height: 2rem;\n  display: flex;\n  flex-direction: row;\n}\n\n.selection_container button {\n  width: 50%;\n  height: 100%;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-evenly;\n  padding: 0 1rem;\n}\n\n.selection_container button:hover {\n  background-color: #f2f7e9;\n}\n\n.selection_container button:first-child {\n  border-right: 1px solid #d0d0ce;\n}\n\n.filter_footer {\n  display: flex;\n  flex-direction: row;\n  align-items: end;\n  justify-content: end;\n  margin-top: 3rem;\n}\n\n.btn {\n  height: 2.3rem;\n  width: 5rem;\n  margin-left: 1rem;\n  cursor: pointer;\n}\n\n.filter_cancel {\n  border: 1px solid var(--primary-main);\n  color: var(--primary-main);\n  border-radius: 5px;\n  background-color: transparent;\n}\n\n.filter_apply {\n  border: 1px solid var(--primary-main);\n  color: white;\n  border-radius: 5px;\n  background-color: var(--primary-main);\n}\n\n.filter_apply:disabled {\n  background-color: #d0d0ce;\n  color: #53565a;\n  cursor: not-allowed;\n  border: none;\n}\n\n.items_filter_list {\n  height: 15vh;\n  width: 90;\n  border: 1px solid #d0d0ce;\n  background-color: #53565a00;\n  margin-top: 1rem;\n  border-radius: 5px;\n  padding: 0rem 1rem;\n  overflow-y: scroll;\n}\n\n.filter_header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.row_header_btn {\n  background-color: transparent;\n  border: none;\n  width: 100%;\n  padding: 0;\n}\n\n.header_name_container {\n  font-size: 14px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
